import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Button from '../components/ui/Button';
import './SimplePage.css';

const NotFoundPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <>
        <title>404 — Page Not Found | ThirdRail Avenue</title>
      </>
      <Navbar />
      <main id="main-content" className="simple-page">
        <div className="simple-page__glow" />
        <div className="simple-page__content tra-container">
          <div className="simple-page__404">404</div>
          <h1>Page not found</h1>
          <p>The page you're looking for doesn't exist or has moved.</p>
          <Button to="/" variant="primary" size="lg" arrow>Back to Home</Button>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFoundPage;
